// extracted by mini-css-extract-plugin
export default {"base":"CbsaStats_base__5acfx","header":"CbsaStats_header__gW3T1"};